import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	SoundManagementList
} from '../../components/sound-management/';

class SoundManagement extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div>
				<Row className="mb-3">
					<Col md="6">
						<h1>Sound Management</h1>
					</Col>
				</Row>
				<Row>
					<Col md="12">
            <SoundManagementList />
					</Col>
				</Row>
			</div>
		);
	}
}

export default SoundManagement;
